import { Component } from '@angular/core';
import { FormService } from '../../../@core/services/form-config.service';
import { FormConfig } from '../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../components/genericBaseModelDropDown';

@Component({
  selector: 'app-form-config-drop-down',
  template: '',
  providers: [FormService],
  standalone: true
})
export class FormConfigDropDownComponent extends GenericBaseModelDropDown<FormConfig> {

  constructor(private service: FormService) {
    super(service, "FormConfig");
  }

}
